import {MattressFabricLayout} from "@cm/mattress-nodes"
import {SelectionPossibilities} from "@template-editor/components/value-slot/value-slot.component"

export const mattressFabricLayoutSelectionPossibilities: SelectionPossibilities<MattressFabricLayout> = [
    {name: "Waterfall", value: "Waterfall"},
    {name: "Inverted Waterfall", value: "InvertedWaterfall"},
    {name: "Border", value: "Border"},
    {name: "Border with Mirror", value: "BorderWithMirror"},
    {name: "All over wrap", value: "AllOverWrap"},
]
